/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./Ravebubble'], function(Ravebubble) {
	'use strict';
	class Ravescatter extends Ravebubble {
		constructor(){
			super();
		}
		get config(){
			const config = super.config;
			config.type = 'Scatter';

			//slots
			delete config.slots.color.supportsMaintainAxisScale;

			config.slots.x.treatOrdinalAsCategory = true;
			delete config.slots.x.supportsMaintainAxisScale;

			config.slots.y.treatOrdinalAsCategory = true;
			delete config.slots.y.supportsMaintainAxisScale;

			config.slots.size = {
				'hidden':true,
				'icon':'size_by'
			};

			config.slots.categories.icon = 'points';

			config.slots.repeatHorizontal.actions = [
				'formatAction',
				'sortAction',
				'topBottomAction'
			];

			config.slots.repeatVertical.actions = [
				'formatAction',
				'sortAction',
				'topBottomAction'
			];

			config.groupedProperty['itemAxis.ticks.labels.color'][1] = 'valueLabels.color';
			config.groupedProperty['itemAxis.ticks.labels.font'][1] = 'valueLabels.font';


			delete config.propertyPrefixes.size;
			delete config.properties['size.title'];

			config.properties['valueLabels.color'] = {
				'colorClass': true,
				'addButton': true
			};

			config.properties['bubble.size'] = {
				'active': true
			};

			config.properties['bubble.size.minValue'] = {
				'active': false
			};

			config.properties['bubble.size.maxValue'] = {
				'active': false
			};

			//include
			const forbidden =  ['labels.font', 'labels.color', 'size.title'];
			config.config.include = config.config.include.filter(property => forbidden.indexOf(property) === -1);
			config.config.include.push('valueLabels.font', 'valueLabels.color');

			return config;
		}
	}
	return Ravescatter;
});
